import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-lenangio-logo-loader',
  templateUrl: './lenangio-logo-loader.component.html',
  styleUrls: ['./lenangio-logo-loader.component.scss']
})
export class LenangioLogoLoaderComponent implements OnInit {

  @Input() loaderMessage: string = 'Loading...';

  constructor() { }

  ngOnInit() {
  }

}
